<template>
  <section class="docmain-section">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 col-lg-8">
          <div class="docmain-container">
            <div class="getting-details">
              <p>{{ $t("doc.menu.Channels") }}</p>
              <img
                src="../../../../../assets/images/up-arrow.svg"
                alt="logo"
                class="right-arrow"
              />
              <p>{{ $t("home.header.Gmail") }}</p>
              <img
                src="../../../../../assets/images/up-arrow.svg"
                alt="logo"
                class="right-arrow"
              />
              <a href="#">{{ $t("Advance.Channels.Email.ConfigureIMAP.tittle") }}</a>
            </div>

            <div class="email-channel-page">
              <div class="channel-details">
                <h1>{{ $t("Advance.Channels.Email.ConfigureIMAP.configure") }}</h1>

                <p>
                  {{ $t("Advance.Channels.Email.ConfigureIMAP.gmail") }}
                  <a href="#">{{ $t("Advance.Channels.Email.ConfigureIMAP.inbox") }}</a>
                </p>
              </div>

              <section class="channel-steps-wrp">
                <div class="channel-steps">
                  <p>
                    <b>{{ $t("Advance.Channels.Email.ConfigureIMAP.step1") }}</b
                    >{{ $t("Advance.Channels.Email.ConfigureIMAP.settings") }}
                  </p>
                  <div class="channel-image-box">
                    <img
                      class="img-fluid"
                      src="../../../../../assets/images/12.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="channel-steps">
                  <p>
                    <b>{{ $t("Advance.Channels.Email.ConfigureIMAP.step2") }}</b>
                    {{ $t("Advance.Channels.Email.ConfigureIMAP.requiredFields") }}
                  </p>
                  <div class="channel-steps-details">
                    <ol>
                      <li>{{ $t("Advance.Channels.Email.ConfigureIMAP.address") }}</li>
                      <li>{{ $t("Advance.Channels.Email.ConfigureIMAP.port") }}</li>
                      <li>{{ $t("Advance.Channels.Email.ConfigureIMAP.email") }}</li>
                      <li>{{ $t("Advance.Channels.Email.ConfigureIMAP.password") }}</li>
                    </ol>
                    <p>{{ $t("Advance.Channels.Email.ConfigureIMAP.help") }}</p>
                    <ul>
                      <li>
                        {{ $t("Advance.Channels.Email.ConfigureIMAP.2step") }}
                        <a href="#">{{
                          $t("Advance.Channels.Email.ConfigureIMAP.appPassword")
                        }}</a>
                      </li>
                      <li>
                        {{ $t("Advance.Channels.Email.ConfigureIMAP.gmailAccounts") }}
                        <a href="#">{{
                          $t("Advance.Channels.Email.ConfigureIMAP.secureAccess")
                        }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="channel-image-box">
                    <img
                      class="img-fluid"
                      src="../../../../../assets/images/12.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="channel-steps">
                  <p>
                    <b>{{ $t("Advance.Channels.Email.ConfigureIMAP.step3") }}</b
                    >{{ $t("Advance.Channels.Email.ConfigureIMAP.testEverything") }}
                  </p>
                  <div class="channel-image-box">
                    <img
                      class="img-fluid"
                      src="../../../../../assets/images/create-email-channel-settings-in-chatwoot.png"
                      alt=""
                    />
                  </div>
                </div>
              </section>

              <section id="next-steps" class="create-channels-emial">
                <div class="channels-title">
                  <p>
                    {{ $t("Advance.Channels.Email.ConfigureIMAP.configureEmailInbox") }}
                  </p>
                  <ol class="next-details">
                    <li>
                      <a href="#"
                        >{{ $t("Advance.Channels.Email.ConfigureIMAP.forwardEmail") }}
                      </a>
                    </li>
                    <li>
                      <a href="#"
                        >{{ $t("Advance.Channels.Email.ConfigureIMAP.tittle") }}
                      </a>
                    </li>
                  </ol>
                </div>
              </section>
            </div>

            <div class="edit-update-detail">
              <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40"
                                    class="iconEdit_dcUD" aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.Channels.Email.ConfigureIMAP.editPage') }}</a>
                            </div> -->
              <p>
                {{ $t("Advance.Channels.Email.ConfigureIMAP.lastUpdatedOn") }}
                <span class="dark">
                  {{ $t("Advance.Channels.Email.ConfigureIMAP.date") }}
                </span>
                {{ $t("Advance.Channels.Email.ConfigureIMAP.by") }}
                <span class="dark">
                  {{ $t("Advance.Channels.Email.ConfigureIMAP.shivam") }}</span
                >
              </p>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="create-chat-woot-account">
                  <p class="preview">
                    {{ $t("Advance.Channels.Email.ConfigureIMAP.previous") }}
                  </p>

                  <router-link
                    to="/docs/product/channels/email/create-channel"
                    class="introduction-account"
                  >
                    <span>{{ $t("Advance.Channels.Email.ConfigureIMAP.side") }}</span>
                    {{ $t("Advance.Channels.Email.ConfigureIMAP.createChannel") }}
                  </router-link>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="create-chat-woot-account">
                  <p>{{ $t("Advance.Channels.Email.ConfigureIMAP.next") }}</p>

                  <router-link to="/docs/product/channels/email/configure-smtp">
                    {{ $t("Advance.Channels.Email.ConfigureIMAP.smtp") }}
                    <span>{{ $t("Advance.Channels.Email.ConfigureIMAP.arrow") }}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4">
          <section class="tableOfContents">
            <!-- <div class="tableOfContents-list">
                            <ul id="side_section_info">
                                <li id="menu_item_1"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_1' }"><a
                                        href="#channels-info">Channels</a></li>
                                <li id="menu_item_2"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_2' }"><a
                                        href="#features-info">Features</a></li>
                                <li id="menu_item_3"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_3' }"><a
                                        href="#integration-info">Integration</a></li>
                                <li id="menu_item_4"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_4' }"><a
                                        href="#advanced-info">Advanced</a></li>
                                <li id="menu_item_5"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_5' }"><a
                                        href="#mobile-app-info">Mobile app</a></li>
                                <li id="menu_item_6"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_6' }"><a
                                        href="#other-info">Others</a></li>
                                <li id="menu_item_7"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_7' }"><a
                                        href="#compatibility-info">Compatibility and Requirements</a></li>
                                <li id="menu_item_8"
                                    :class="{ 'active_menu_item': activeMenuItem === 'menu_item_8' }"><a
                                        href="#next-steps">Next Steps</a></li>
                            </ul>
                        </div> -->
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SideBar from "@/components/SideBar.vue";
import MainContent from "@/components/MainContent.vue";

export default {
  name: "Introduction",
  data() {
    return {
      isToggle: false,
    };
  },
  components: {
    Header,
    Footer,
    SideBar,
    MainContent,
  },
  methods: {
    handleToggle() {
      this.isToggle = !this.isToggle;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
